module.exports = __webpack_public_path__ + "img/142ne.e26e15d7.svg";